import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';

import styles from './Toggle.module.scss';

type Props = {
  classNames?: string;
  checked?: boolean;
  onChange?: () => void;
  children?: ReactNode;
  disabled?: boolean;
};

const Toggle = ({
  classNames,
  checked,
  onChange,
  children,
  disabled,
}: Props) => {
  return (
    <label
      className={classes([
        styles.switch,
        styles.checkboxWrapper,
        styles.container,
        classNames,
      ])}
    >
      <input
        onChange={onChange}
        checked={checked}
        type="checkbox"
        className={styles.controlSwitchInput}
        name="express"
        disabled={disabled}
      />
      <div className={styles.controlSwitchMark} />
      {children}
    </label>
  );
};

export default observer(Toggle);
